import { LoadingOverlay as MantineLoadingOverlay, LoadingOverlayProps, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';
import Loader from './Loader';

export type GradientVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export interface ThemedLoadingOverlayProps extends Omit<LoadingOverlayProps, 'loader'> {
  gradientVariant?: GradientVariant;
  blurBackground?: boolean;
  loaderSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const LoadingOverlay = forwardRef<HTMLDivElement, ThemedLoadingOverlayProps>(
  (
    {
      gradientVariant = 'primary',
      blurBackground = true,
      loaderSize = 'lg',
      overlayProps,
      ...rest
    },
    ref
  ) => {
    const theme = useMantineTheme();

    return (
      <MantineLoadingOverlay
        ref={ref}
        loader={<Loader size={loaderSize} gradientVariant={gradientVariant} />}
        overlayProps={{
          ...overlayProps,
          style: {
            backdropFilter: blurBackground ? 'blur(4px)' : undefined,
            ...(overlayProps as any)?.style,
          },
        }}
        {...rest}
      />
    );
  }
);

LoadingOverlay.displayName = 'LoadingOverlay';

export default LoadingOverlay;
